import React from 'react';
import { Link } from '../../../../spa/Components/Link/Link';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import {
    BB_RACING_WIDGET_RACECARD_FOOTER_CLASS,
    BB_RACING_WIDGET_RACECARD_FOOTER_STREAMING_CLASS,
    BB_RACING_WIDGET_RACECARD_FOOTER_GTM,
} from '../../constants';
import { seoUrlEvent } from '../../../../spa/Utils/SeoUrls';

const propTypes = {
    racecardUrls: PropTypes.object,
    events: PropTypes.object,
    eventId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    source: PropTypes.string,
    type: PropTypes.string,
};

const RaceCardFooter = ({ eventId, racecardUrls, events, source, type }) => {
    const streamingEnabled = Boolean(events[eventId].details.streaming_enabled);
    const streamingClass = streamingEnabled ?
        BB_RACING_WIDGET_RACECARD_FOOTER_STREAMING_CLASS : '';

    const gtm = `${source};${type}-widget;${BB_RACING_WIDGET_RACECARD_FOOTER_GTM}`;

    return (
        <Link
            to={`${seoUrlEvent(racecardUrls[eventId], eventId)}`}
            className={`${BB_RACING_WIDGET_RACECARD_FOOTER_CLASS } ${streamingClass}`}
            gtmAttribute={gtm}
        >
            <Trans i18nKey="racing.view_racecard" />
        </Link>
    );
};

RaceCardFooter.propTypes = propTypes;

export default RaceCardFooter;
